import { withStyles } from "@material-ui/core";
import EditCustomerForm from "./Form";
const styles = (theme) => ({
  paperAnchor: {
    top: 50,
    margin: '4 10 10 10',
    backgroundColor: theme.gridBGColor,
    transition: theme.transitions.create(["width"], {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'hidden',
    borderRadius: '4px',
  },
  paperHidden: {
    height: 0,
    width: 0,
  },
  backdrop: {
    position: "absolute",
    backgroundColor: "transparent",
  },
  modal: {
    position: "absolute",
  },
});

const EditCustomerFullScreenDialog = ({ classes, open, ...rest }) => {
  return (
    <EditCustomerForm
      open={open}
      anchor="bottom"
      variant="persistent"
      drawerClasses={{
        paper: `${classes.paperAnchor} ${
          !open ? classes.paperHidden : ""
        }`,
        modal: classes.modal,
      }}
      BackdropProps={{
        className: classes.backdrop,
      }}
      {...rest}
    />
  );
};

export default withStyles(styles)(EditCustomerFullScreenDialog);
